import React from 'react';
import { Col, Row } from 'react-styled-flexboxgrid';
import { WaterFitNav } from '@savewatersavemoney/swsm-ui';
import { AppReducer, UserReducer } from '../../interfaces';
import { useTranslation } from 'react-i18next';
import { isLoggedIn } from '../../helpers';
interface WithHeaderProps {
  appWidth: number;
  app: AppReducer;
  getGeneralData: Function;
  user: UserReducer;
  swsmLocation: any;
  children: any;
}
const WithHeader: React.FC<WithHeaderProps> = props => {
  const { appWidth, app, getGeneralData, children, swsmLocation } = props;
  const isDesktop = appWidth > 800;

  const [t] = useTranslation('common');
  const litres = t('portal.waterfitnav.litres');

  const logged = Boolean(isLoggedIn());
  React.useEffect(() => {
    getGeneralData();
  }, [getGeneralData]);

  return logged ? (
    <Row id="nav-row">
      <Col sm={8} xs={6}>
        <WaterFitNav
          tooltips={{
            water: `${t('portal.waterfitnav.tooltip_litres')}`,
            coins: `${t('portal.waterfitnav.tooltip_coins')}`,
          }}
          isDesktop={isDesktop}
          waterUsage={
            swsmLocation.pathname === '/myshop' || swsmLocation.pathname.includes('/myshop/')
              ? null
              : app.generalData.data?.totalWaterSaved
          }
          coins={app.generalData.data?.coins}
          litresCopy={litres}
        ></WaterFitNav>
      </Col>
      <Col sm={4} xs={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
        {children}
      </Col>
    </Row>
  ) : null;
};
export default WithHeader;
